import * as MatchStatus from 'customer-data-filters-ui/filterQueryFormat/MatchStatus';
import { useContext, useMemo } from 'react';
import { useStrategy } from '../../hooks/useStrategy';
import ViewerConditionsGroupActions from './ViewerConditionsGroupActions';
import ViewerConditionsGroupConditions from './ViewerConditionsGroupConditions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import ViewerConditionsGroupMatchStatusTag from './ViewerConditionsGroupMatchStatusTag';
import styled from 'styled-components';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GroupContainer = styled.div.attrs({
  'data-highlight-target': 'viewer-conditions-group',
  'data-test-id': 'viewer-conditions-group'
})(({
  useOnePanel,
  theme,
  defaultFormat,
  matchFail,
  matchPass
}) => {
  const divStyles = {
    position: 'relative',
    borderRadius: theme.borderRadius[100],
    zIndex: useOnePanel ? 'unset' : 1
  };
  if (defaultFormat) {
    divStyles.padding = theme.space[300];
    divStyles.backgroundColor = theme.color['fill-tertiary-default'];
  }
  if (useOnePanel) {
    divStyles.paddingInline = theme.space[400];
    divStyles.paddingBlock = theme.space[200];
    divStyles.borderRadius = theme.borderRadius[300];
    divStyles.border = `1px solid`;
    if (matchFail) {
      divStyles.borderColor = theme.color['border-alert-default'];
    } else if (matchPass) {
      divStyles.borderColor = theme.color['border-positive-default'];
    } else {
      divStyles.borderColor = theme.color['border-core-default'];
    }
  } else {
    if (matchFail) {
      divStyles.backgroundColor = theme.color['fill-alert-subtle'];
    } else if (matchPass) {
      divStyles.backgroundColor = theme.color['fill-positive-subtle'];
    }
  }
  const beforeStyles = {};
  divStyles['&::before'] = beforeStyles;
  if (defaultFormat) {
    beforeStyles.content = '""';
    beforeStyles.position = 'absolute';
    beforeStyles.top = 0;
    beforeStyles.bottom = 0;
    beforeStyles.left = 0;
    beforeStyles.right = 0;
    beforeStyles.border = `1px solid ${theme.color['text-primary-disabled']}`;
    beforeStyles.borderRadius = theme.borderRadius[100];
    beforeStyles.zIndex = -1;
  }
  if (matchFail) {
    beforeStyles.borderColor = theme.color['border-alert-default'];
  } else if (matchPass) {
    beforeStyles.borderColor = theme.color['fill-positive-default'];
  }
  return divStyles;
});
const ViewerConditionsGroup = props => {
  var _testFiltersStatus$fi, _logicGroupMatchStatu;
  const {
    inputUse,
    logicGroup,
    logicGroupIndex,
    matchStatus: matchStatusFromProps,
    showLogicGroupOperatorToggles = false
  } = props;
  const {
    isTestFiltersEnabled
  } = useStrategy();
  const {
    testFiltersStatus,
    isInTestFilters,
    props: {
      isAndGroup,
      layout,
      useNarrowPanelFormat,
      useOnePanel,
      showTestFilters
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const isTestFiltersOn = isTestFiltersEnabled && (isInTestFilters || showTestFilters);
  const logicGroupMatchStatusData = isTestFiltersOn ? testFiltersStatus === null || testFiltersStatus === void 0 || (_testFiltersStatus$fi = testFiltersStatus.filtersData) === null || _testFiltersStatus$fi === void 0 ? void 0 : _testFiltersStatus$fi[logicGroupIndex] : undefined;
  const matchStatus = (_logicGroupMatchStatu = logicGroupMatchStatusData === null || logicGroupMatchStatusData === void 0 ? void 0 : logicGroupMatchStatusData.status) !== null && _logicGroupMatchStatu !== void 0 ? _logicGroupMatchStatu : matchStatusFromProps;
  const MatchStatusTag = useMemo(() => {
    return /*#__PURE__*/_jsx(ViewerConditionsGroupMatchStatusTag, {
      logicOperator: logicGroup.logicGroupName,
      matchStatus: matchStatus,
      useOnePanel: useOnePanel
    });
  }, [logicGroup.logicGroupName, matchStatus, useOnePanel]);
  return /*#__PURE__*/_jsxs(GroupContainer, {
    defaultFormat: !useOnePanel && (layout === 'embedded' || !useNarrowPanelFormat),
    matchFail: matchStatus === MatchStatus.FAIL,
    matchPass: matchStatus === MatchStatus.PASS,
    useOnePanel: !!useOnePanel,
    children: [/*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      alignItems: "center",
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          flexGrow: 1
        },
        children: [!isAndGroup && /*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          justifyContent: "space-between",
          marginBlockStart: "-100",
          marginBlockEnd: "100",
          minBlockSize: "32px",
          children: [/*#__PURE__*/_jsxs(Flex, {
            columnGap: "400",
            rowGap: "100",
            alignItems: "end",
            flexWrap: "wrap",
            children: [/*#__PURE__*/_jsx(H5, {
              marginBlock: "0",
              paddingBlockStart: "200",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "newCustomerDataFilters.filtersViewer.groupHeading",
                options: {
                  groupIndex: logicGroupIndex + 1
                }
              })
            }), useOnePanel && /*#__PURE__*/_jsx(Box, {
              children: MatchStatusTag
            })]
          }), /*#__PURE__*/_jsx(Box, {
            flexShrink: 0,
            children: /*#__PURE__*/_jsx(ViewerConditionsGroupActions, {
              logicGroupIndex: logicGroupIndex
            })
          })]
        }), !useOnePanel && MatchStatusTag]
      })
    }), /*#__PURE__*/_jsx(ViewerConditionsGroupConditions, {
      inputUse: inputUse,
      logicGroup: logicGroup,
      logicGroupIndex: logicGroupIndex,
      logicGroupMatchStatusData: logicGroupMatchStatusData,
      showLogicGroupOperatorToggles: showLogicGroupOperatorToggles
    })]
  });
};
export default ViewerConditionsGroup;